import { render, staticRenderFns } from "./RelatorioFiltros.vue?vue&type=template&id=20991339&scoped=true"
import script from "./RelatorioFiltros.vue?vue&type=script&lang=ts"
export * from "./RelatorioFiltros.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioFiltros.vue?vue&type=style&index=0&id=20991339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20991339",
  null
  
)

export default component.exports